"use strict";

jQuery(document).ready(function ($) {
  $('.video__carousel').on('init', function (event, slick, direction) {
    // check to see if there are one or less slides
    if (!($('.video__carousel .slick-slide').length > 1)) {
      // remove dots
      $('.video__dots').hide();
    }
  });
  $('.video__carousel').slick({
    infinite: true,
    centerPadding: '60px',
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    dotsClass: 'video__dots',
    dots: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        dots: true
      }
    }, {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        dots: true
      }
    }]
  });
});